<ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name"
    [disabled]="false" [autoClearSearch]="false" [(ngModel)]="selectedRanking" placeholder="Seleccionar Ranking"
    (select)="changeRanking($event)">

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrado
    </ng-template>

</ngx-select>